import { NOTE_CLASS } from "../../lib/ui.js";
import { displayConfigValue } from "./documentDiff.js";

const LINE_LIMIT = 50;

/// One entry for each changed subsection, with one before-and-after line for
/// each changed pointer. Changes outside every subsection follow under their
/// own names, so the list always accounts for the whole count.
export default function ChangeList({ definition, tally }) {
    const groups = [];
    for (const category of definition.categories) {
        for (const subsection of category.subsections) {
            const changes = tally.subsections.get(subsection.id) ?? [];
            if (changes.length) groups.push({ id: subsection.id, label: subsection.label, changes });
        }
    }
    if (tally.preserved.length) groups.push({ id: "preserved", label: "Settings without a control", changes: tally.preserved });
    if (tally.unaccepted.length) groups.push({ id: "unaccepted", label: "Settings the server no longer accepts", changes: tally.unaccepted });
    if (!groups.length) return null;
    let shown = 0;
    return (
        <div className="grid gap-[10px]">
            {groups.map((group) => {
                const lines = group.changes.slice(0, Math.max(0, LINE_LIMIT - shown));
                shown += lines.length;
                if (!lines.length) return null;
                return (
                    <div key={group.id} className="grid gap-[4px] border-t border-[color:var(--line)] pt-[10px]">
                        <strong className="text-[11px] font-medium text-[color:var(--ink)]">{group.label}</strong>
                        {lines.map((change) => (
                            <div key={`${change.pointer}:${change.member ?? ""}`} className="grid gap-[2px] border-l-2 border-[color:var(--line-strong)] pl-[8px] text-[9px]">
                                <code>{change.pointer}</code>
                                <span className="break-all text-[color:var(--muted)]">{change.beforeFound ? displayConfigValue(change.before) : "not present"} -&gt; {change.afterFound ? displayConfigValue(change.after) : "removed"}</span>
                            </div>
                        ))}
                    </div>
                );
            })}
            {tally.total > LINE_LIMIT ? <p className={`${NOTE_CLASS} m-0`}>{tally.total - LINE_LIMIT} additional setting changes are shown in the composed document.</p> : null}
        </div>
    );
}
